import React from 'react';

const IconBrands = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20.66" height="20.66" viewBox="0 0 20.66 20.66">
    <path id="circle-star" d="M10.33,0A10.33,10.33,0,1,0,20.66,10.33,10.329,10.329,0,0,0,10.33,0Zm5.863,9.329-2.4,2.338.569,3.3a.728.728,0,0,1-1.055.765L10.33,14.171,7.36,15.733A.727.727,0,0,1,6.3,14.968l.569-3.3L4.467,9.329a.726.726,0,0,1,.4-1.239l3.322-.483L9.676,4.6a.728.728,0,0,1,1.3,0l1.485,3,3.322.483A.738.738,0,0,1,16.193,9.329Z" fill="#1d3853" />
  </svg>
);

export default IconBrands;
